export const SKILL_STORE = 'SKILL_STORE';
export const SKILL_UPDATE = 'SKILL_UPDATE';
export const SKILL_DESTROY = 'SKILL_DESTROY';
